import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M3 11a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0zm4-3a1 1 0 0 1 2 0v8a1 1 0 1 1-2 0zm4-4a1 1 0 1 1 2 0v16a1 1 0 1 1-2 0zm4 2a1 1 0 1 1 2 0v12a1 1 0 1 1-2 0zm4 5a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0z"
    }
  )
);
var SvgSoundWaveFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SoundWaveFilled_default = SvgSoundWaveFilled;

export { SoundWaveFilled_default as default };
